<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconAndroidLogo_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M17.103 14.844A.922.922 0 1 1 17.102 13a.922.922 0 0 1 0 1.844Zm-10.194 0a.922.922 0 1 1 0-1.843.922.922 0 0 1 0 1.843ZM17.433 9.29l1.843-3.192a.384.384 0 1 0-.664-.384l-1.866 3.233a11.377 11.377 0 0 0-4.74-1.014c-1.71 0-3.313.363-4.74 1.014L5.4 5.713a.383.383 0 1 0-.665.384L6.58 9.289C3.414 11.011 1.249 14.214.932 18H23.08c-.317-3.786-2.482-6.99-5.647-8.71Z"
    />
</svg>
